import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";
import StyledAtomicButton from '../../shared/AtomicButton'

const Modal = props => {
	const [windowWidth, setWindowWidth] = useState(0);
	const DynamicButton = props.useButton ? StyledAtomicButton : 'a';

	const getWindowWidth = () => {
		setWindowWidth(window.innerWidth);
	};

	useEffect(() => {
		getWindowWidth();
		window.addEventListener('resize', getWindowWidth);

		return () => {
			window.removeEventListener('resize', getWindowWidth);
		};
	}, []);

	return (
		<CSSTransition in={props.show} unmountOnExit timeout={1000} classNames="modal">
			<div
				className="modal-component-wrapper"
				style={{ position: props.fixed ? "fixed" : "absolute" }}
			>
				<div
					className={`modal-component ${windowWidth <= props.width ? 'responsive' : ''}`}
					style={{ width: `${windowWidth <= props.width ? 'auto' : `${props.width}px`}`, height: props.height ? `${props.height}px` : 'fit-content' }}
				>
					<p className="modal-component--title">
						<strong>{props.title}</strong>
						{props.cancel && !props.withoutClose ? (
							<i className="icon-close" onClick={props.onCancel} />
						) : (
							""
						)}
					</p>
					<div className="modal-component--description">
						{props.children && props.children}
						{props.description && props.description}
					</div>
					<div className="modal-component--buttons">
						{(props.cancel && !props.confirmTwo) && (
							<a
								className="modal-component--cancel"
								onClick={props.onCancel}
								{...(props.dataActionCancel ? { "data-action": props.dataActionCancel } : {})}
							>
								{props.cancel}
							</a>
						)}
						{props.confirm && (
							<DynamicButton
								className={!props.useButton ? "modal-component--confirm" : 'modal-component--button'}
								onClick={props.onConfirm}
								disabled={props.disabledConfirm}
								{...(props.dataActionConfirm ? { "data-action": props.dataActionConfirm } : {})}
							>
								{props.confirm}
							</DynamicButton>
						)}
						{props.confirmTwo && (
							<DynamicButton
								className={!props.useButton ? "modal-component--confirm modal-component--confirm-two" : 'modal-component--button'}
								onClick={props.onConfirmTwo}
								disabled={props.disabledConfirmTwo}
								{...(props.dataActionConfirmTwo ? { "data-action": props.dataActionConfirmTwo } : {})}
							>
								{props.confirmTwo}
							</DynamicButton>
						)}
					</div>
				</div>
			</div>
		</CSSTransition>
	);
};

Modal.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	title: PropTypes.string,
	description: PropTypes.any,
	children: PropTypes.any,
	confirm: PropTypes.string,
	confirmTwo: PropTypes.string,
	cancel: PropTypes.any,
	onCancel: PropTypes.func,
	onConfirm: PropTypes.func,
	onConfirmTwo: PropTypes.func,
	useButton: PropTypes.bool,
	show: PropTypes.bool,
	withoutClose: PropTypes.bool,
	disabledConfirm: PropTypes.bool,
	disabledConfirmTwo: PropTypes.bool
};

Modal.defaultProps = {
	width: 300,
	useButton: false,
	show: false
};

export default Modal;
